module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/product-detail/product-detail-edit/product-detail-edit.component.scss
// module id = ./src/app/components/products/product-detail/product-detail-edit/product-detail-edit.component.scss
// module chunks = main